import { injectService } from '@patsnap/tahiti-core';
import type { PatsnapCopilotUsage } from '../../patsnap-copilot-service.interface';
import { PatsnapCopilotUsageService } from '../../patsnap-copilot-usage-service';
import { ref, onMounted } from 'vue';

export function useCopilotUsage() {

    const enabled = ref(false);
    const patsnapCopilotUsage = ref<PatsnapCopilotUsage | undefined>(undefined);

    onMounted(() => {
        const patsnapCopilotUsageService = injectService<PatsnapCopilotUsageService>(PatsnapCopilotUsageService);
        patsnapCopilotUsageService.getUsage().then(usage => {
            enabled.value = usage.enabled;
            patsnapCopilotUsage.value = usage;
        });
    });

    return {
        enabled,
        patsnapCopilotUsage,
    };
}
